import { JSX, ReactNode } from 'react';
import { Box, Divider, Typography } from '@mui/material';

/**
 * A titled block of an edit form, with its explanation given once above the
 * fields it governs. Purely presentational: it holds no form state, so inputs
 * placed inside keep their sources exactly as they would outside it.
 */
export function FormSection(props: { title: string, hint?: ReactNode, children: ReactNode }): JSX.Element {
    return (
        <Box sx={ { width: '100%' } }>
            <Typography variant="subtitle2"
                        sx={ { textTransform: 'uppercase', letterSpacing: '0.08em', color: 'text.secondary' } }>
                { props.title }
            </Typography>
            { props.hint &&
                <Typography variant="caption" sx={ { display: 'block', color: 'text.secondary', marginTop: '2px' } }>
                    { props.hint }
                </Typography>
            }
            <Divider sx={ { margin: '8px 0 16px 0' } } />
            { props.children }
        </Box>
    );
}
